import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class NodeSizeParams extends ConfigNode
  @className = 'NodeSizeParams'

  constructor: ->
    super('nodeSizeParams')

  @load: ->
    super('nodeSizeParams', @)

  update: (key) ->
    @set('value', key)
    @save()

  key: ->
    @get('value')

  reset: ->
    @update(undefined)

export default NodeSizeParams
